module.exports = __webpack_public_path__ + "img/message.3cdab353.svg";